// extracted by mini-css-extract-plugin
export default {"Scripts":"Scripts_Scripts__m3viN"};